import equal from 'fast-deep-equal'
import { logDatadog } from 'services/datadogRum'
import { AppAction } from './types/ActionTypes'
import { SET_OPTIMIZELY_EXPERIMENT, SET_OPTIMIZELY_FLAGS_BULK } from './actionConstants'

export function setOptimizelyExperiment(experimentId: string, experiment: App.OptimizelyExperimentDetails): AppAction {
  return (dispatch, getState) => {
    // You can access state here if needed
    const state = getState()
    if (state.optimizely.optimizelyExperiments[experimentId]?.triggered) {
      return // Already triggered, don't dispatch again
    }

    dispatch({
      type: SET_OPTIMIZELY_EXPERIMENT,
      flagKey: experimentId,
      value: {
        ...experiment,
        triggered: true,
      },
    })
  }
}

export function refreshOptimizelyFlags(): AppAction {
  return async(dispatch, getState) => {
    try {
      const state = getState()
      const regionCode = state.geo.currentRegionCode || 'au'
      const response = await fetch(`/api/flags?region=${regionCode}`)
      if (!response.ok) return

      const data = await response.json()
      const currentFlags = state.optimizely.optimizelyFeatureFlags
      const currentExperiments = state.optimizely.optimizelyExperiments

      const flagsChanged = !equal(currentFlags, data.optimizelyFeatureFlags)
      const experimentsChanged = !equal(currentExperiments, data.optimizelyExperiments)

      if (flagsChanged || experimentsChanged) {
        dispatch({
          type: SET_OPTIMIZELY_FLAGS_BULK,
          optimizelyFeatureFlags: data.optimizelyFeatureFlags,
          optimizelyExperiments: data.optimizelyExperiments,
        })
      }
    } catch(err) {
      logDatadog('refreshOptimizelyFlags failed', { err }, 'error')
    }
  }
}
